var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.27,
    height: 40.578,
    viewBox: "0 0 31.27 40.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7487b8;}.b{fill:#7a9fff;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67.003 -4.363)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M94.487,100.439H68.171A1.168,1.168,0,0,1,67,99.27V63.646a1.168,1.168,0,0,1,1.168-1.168H95.655V99.27A1.168,1.168,0,0,1,94.487,100.439Z",
    transform: "translate(0 -55.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M122.474,72.451H96.158a1.168,1.168,0,0,1-1.168-1.168V35.659a1.168,1.168,0,0,1,1.168-1.168h26.315a1.168,1.168,0,0,1,1.168,1.168V71.283A1.168,1.168,0,0,1,122.474,72.451Z",
    transform: "translate(-25.369 -30.128)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.185 8.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 17.522,
    height: 1.46,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 17.522,
    height: 1.46,
    transform: "translate(0 5.196)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 17.522,
    height: 1.46,
    transform: "translate(0 10.391)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 17.522,
    height: 1.46,
    transform: "translate(0 15.587)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.185 29.373)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 17.522,
    height: 1.46,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 17.522,
    height: 1.46,
    transform: "translate(0 5.196)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaDocument);
export default __webpack_public_path__ + "static/media/media-document.aecc591d7d17c8df2dc2e52135c96c52.svg";
export { ForwardRef as ReactComponent };